import type { ProcessingJobList } from "./api";
import { getProjectMeta } from "./projectMeta";

export function getProjectName(job: ProcessingJobList): string {
  // 1. User's custom title. The backend value (persisted via rename) wins; the
  //    local meta is an optimistic fallback and only counts when the user
  //    actually edited it (auto-named titles must not shadow the filename),
  //    so the page title == DOCX name == PDF name.
  if (job.custom_title?.trim()) return job.custom_title.trim();
  const meta = getProjectMeta(job.id);
  if (meta?.customTitle && meta.titleEditedByUser) return meta.customTitle;

  // 2. Uploaded file name without its extension. Mirrors the backend
  //    _job_display_title so the page title == DOCX name == PDF name.
  const stem = job.original_filename?.replace(/\.[^/.]+$/, "").trim();
  if (stem) return stem;

  // 3. Lead summary preview, as a last resort.
  if (job.report_preview?.summary) {
    const text = job.report_preview.summary.trim();
    if (text.length <= 50) return text;
    return text.slice(0, 50) + "...";
  }

  return job.title;
}
